import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import OverviewCard from "./OverviewCard";
import { FormattedMessage } from "react-intl";
import placeHolder from "../../assets/placeholder.jpg";
import { shortenString } from "../../utils/shortenString";
import SecureLS from "secure-ls";
import CardButtons from "./CardButtons";
import { useSelector } from "react-redux";
import SwiperCarousal from "../Carousal/SwiperCarousal";
import { Height } from "@mui/icons-material";

const CarCard = (props) => {
  const ls = new SecureLS({ encodingType: "aes" }); // initialise secure ls
  const isMob = useSelector((state) => state.global.isMobile);
  const [carImages, setCarImages] = useState();

  // destructure prop object
  const {
    title,
    defaultImg,
    bodyTypeEn,
    warrantyTillDate,
    yearOfManufacture,
    mileage,
    carSlug,
    usedCarUUID,
    images,
  } = props.data;

  //define card overview to display only 4 items from the overview
  const cardOverView = {
    bodyTypeEn: bodyTypeEn,
    warrantyTillDate: warrantyTillDate,
    yearOfManufacture: yearOfManufacture,
    mileage: mileage,
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (images) {
      const imageUrls = images
        ? images
            .split(",")
            .map(
              (image) =>
                `https://fazaacar.s3.ap-south-1.amazonaws.com/usedcars/${image.trim()}`
            )
        : [];
      setCarImages(imageUrls);
    }
  }, [images]);

  const getCarImages = (imgArr) => {
    const newArr = [];
    // imgArr?.map((img) => {
    //   newArr.push(
    //     `https://fazaacar.s3.ap-south-1.amazonaws.com/usedcars/${img}`
    //   );
    // });
    return newArr;
  };

  return (
    <Card
      variant="outlined"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: "1rem",
        height: "100%",
        "&:hover": {
          cursor: "pointer",
        },
        position: "relative",
      }}
    >
      <Link
        to={`/${carSlug}?carId=${usedCarUUID}`}
        underline="none"
        state={{ carId: usedCarUUID }}
        style={{
          textDecoration: "none",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {carImages?.length > 0 ? (
          <CardMedia
            // sx={{ maxHeight: "180px" }}
            children={
              <SwiperCarousal
                data={carImages}
                // heightMob="320"
                // heightDesk="180"
                swiperOnCard={true}
              />
            }
          />
        ) : (
          <CardMedia
            component="img"
            sx={{ objectFit: "cover" }}
            image={`${placeHolder}`}
            alt={title}
          />
        )}
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: { xs: "-12%", md: "-9%" },
              right: "1rem",
              zIndex: 9,
            }}
          >
            <CardButtons
              status=""
              favourite={false}
              share={true}
              carname={title}
              slug={carSlug}
              carId={usedCarUUID}
            />
          </Box>
          <Typography
            variant={isMob ? "h5" : "h3"}
            sx={{
              color: "secondary.main",
              fontSize: "26px",
              // margin: "1rem 0",
            }}
          >
            {/* {shortenString(title, 25)} */}
            {title}
          </Typography>
          <Stack direction="row" spacing={1} useFlexGap>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={1}>
                {Object.entries(cardOverView).map(([key, value], index) => (
                  <Grid
                    key={index}
                    item
                    xs={3}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <OverviewCard
                      objKey={key}
                      objValue={value}
                      cardPadding=".5rem"
                      cardVariant="elevation"
                      elevation={0}
                      label={<FormattedMessage id={`app.overview.${key}`} />}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Stack>
        </CardContent>
      </Link>
    </Card>
  );
};

export default CarCard;
